<div class="submenu-dropdown cnt-row" data-testid="pl-submenu-dropdown-popup">
    <scrolldiv class="scroll" [scrollerSize]="20" [navigatorSize]="14" [scrollVerticalIndent]="0" cls="lightScroll" [horizontalScrollAllowed]="false" [style.width.%]="100">
        <div class="arrow-up"></div>
        <div class="cnt-row top">
            <div class="h3font accountTitle b1Color" i18n>{{ 'MOVE_TO_A_DIFFERENT' | translate }}</div>
        </div>
        <div [height]="20"></div>
        <div *ngFor="let item of items"
             class="p2Font"
             (click)="handlePLItemClick(item, '')"
             attr.data-testid="{{item.testId}}">
            <div *ngIf="item.title"
                 class="submenu-dd-item submenu-dd-item-inactive head cnt-row-centered"
                 [ngClass]="{'submenu-dd-item-active': item.title === current.key && (!acc || !acc.AccountSubHeading)}"
                 [attr.data-testid]="item.title === current.key && (!acc || !acc.AccountSubHeading) ? 'submenu-dd-item-active' : 'submenu-dd-item'">
                <div class="curtail filler">{{item.title}}</div>
                <div class="inactive-pointer cnt-row-centered" [ngClass]="{'move-allowed': isMoveAllowed(item, '', acc)}" data-testid="moveHereText">
                    <span class="h5Font" i18n>{{ 'MOVE_HERE' | translate }}</span>
                    <span [width]="5"></span>
                    <div class="back-arrow-dark"></div>
                </div>
                <div class="active-pointer back-arrow"></div>
                <div [width]="10"></div>
            </div>
            <ng-container *ngFor="let it of item.subHeadings">
                <div *ngIf="it"
                     class="submenu-dd-item submenu-dd-item-inactive sub-heading cnt-row-centered"
                     [ngClass]="{'submenu-dd-item-active': acc && acc.AccountSubHeading === it}"
                     (click)="handlePLItemClick(item, it, acc); $event.stopPropagation()"
                     [attr.data-testid]="acc && acc.AccountSubHeading === it ? 'submenu-dd-item-active' : 'submenu-dd-item'">
                    <div class="curtail filler oneline">{{it}}</div>
                    <div class="inactive-pointer cnt-row-centered" [ngClass]="{'move-allowed': isMoveAllowed(item, it, acc)}" data-testid="moveHereText">
                        <span class="oneline h5Font" i18n>{{ 'MOVE_HERE' | translate }}</span>
                        <span [width]="5"></span>
                        <div class="back-arrow-dark"></div>
                    </div>
                    <div class="active-pointer back-arrow"></div>
                    <div [width]="10"></div>
                </div>
            </ng-container>
        </div>
    </scrolldiv>
</div>
